import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { HelpersService } from 'src/app/shared/services/helpers.service';

@Component({
  selector: 'app-multiple-select',
  templateUrl: './multiple-select.component.html',
  styleUrls: ['./multiple-select.component.scss']
})
export class MultipleSelectComponent implements OnInit, OnChanges, OnDestroy {

  @Input() block: any;
  @Input() id: any;
  @Input() positionBlock: any;
  @Input() resetValueCheckbox: boolean = false;
  @Input() isCorsiLaureaTutti: boolean = false;
  @Input() firstInput: boolean = false;
  @Input() lastInput: boolean = false;
  @Output() onSelected = new EventEmitter();
  public checkboxGroupForm: FormGroup;
  public typeahead: FormControl = new FormControl();
  public suggestions: any;
  public options: any[] = [];
  public checkArray!: Observable<any>;
  public titleDropdown: string = '';
  public isValue: boolean = false;
  public viewCheckboxGroupForm = false;

  get ordersFormArray() {
    return this.checkboxGroupForm.controls['checkbox'] as FormArray;
  }

  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute,
    public helpersService: HelpersService) {
    this.checkboxGroupForm = this.formBuilder.group({
      checkbox: new FormArray([])
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['resetValueCheckbox'] && changes['resetValueCheckbox'].currentValue) {
      this.checkboxGroupForm.reset();
      this.isValue = false;
      this.titleDropdown = this.block['label_' + this.helpersService.langCodeApi];
    }
  }

  ngOnDestroy(): void {    
    this.block.value_sel = null;
  }
  
  ngOnInit(): void {
    if (this.block && this.block.filter_name === "field_citta_corso") {
      if (this.block.select_options) {
        const values: any[] = Object.keys(this.block.select_options.values)
        for (let val of values) {
          if (this.block.select_options.values[val] === "Sede di didattica integrativa di Taranto" ||
            this.block.select_options.values[val] === "Sede di didattica integrativa di Palermo - S. Silvia"
          ) {
            delete this.block.select_options.values[val]
          }
        }
      }
    }
    if (this.block.filter_type === 'textList[]') {
      this.generateValuesTextList();
    }
    
    this.addCheckboxes();
    this.titleDropdown = this.block['label_' + this.helpersService.langCodeApi];
    if (this.block.filter_type === 'vocabulary[]') {
      this.checkArray = of(this.block.value);      
      this.typeahead.valueChanges.subscribe(searchKeyword => {
        if (searchKeyword === '') {
          this.checkArray = of(this.block.value);
        }
      });
    }
    if (this.block.filter_type === 'textList[]') {
      this.checkArray = of(this.options);
      this.typeahead.valueChanges.subscribe(searchKeyword => {
        if (searchKeyword === '') {
          this.checkArray = of(this.options);
        }
      });
    }
    this.valueOnInit();
  }

  private valueOnInit(): void {
    if (this.block?.value_sel && this.block?.value_sel[this.block?.filter_name]) {

      let valuesSelected = this.block.value_sel[this.block.filter_name];
      if (!(valuesSelected instanceof Array)) {
        valuesSelected = [valuesSelected];
      }
      let  conf = {
        options: this.options,
        id: 'id'
      }
      if (this.block.value.length) {
        conf = {
          options: this.block.value,
          id: 'term_id'
        }
      }
      const values = [];
      const selectedCheckbox: any = [];
      for (const opt of conf.options) {
        const found = valuesSelected.findIndex( (b: string) => b === opt[conf.id]);
        const value = found >= 0 ? valuesSelected[found] : '';
        values.push(value);
        if (value) {
          selectedCheckbox.push(opt);
        }
      }
      this.checkboxGroupForm.controls['checkbox'].setValue(values);
      this.setTitleDropdown(selectedCheckbox);
    }
  }

  private generateValuesTextList() {
    for (const opt of Object.keys(this.block.select_options.values)) {
      this.options.push({ id: opt, name: this.block.select_options.values[opt] })
    }
    this.options.sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        
        return 0;
    });
  }

  private addCheckboxes() {
    if (this.block.filter_type === 'vocabulary[]') {
      if (this.block.value instanceof Array) {
        this.block.value.forEach(() => this.ordersFormArray.push(new FormControl(false)));
      }
    }
    if (this.block.filter_type === 'textList[]') {
      if (this.options) {
          this.options.forEach(() => this.ordersFormArray.push(new FormControl(false)));
      }
    }
    // if (this.block.filter_type === 'textList[]') {
    //   if (this.options) {
    //       this.options.forEach((el) => {
    //         if (this.block.value_sel && this.block.value_sel.values_selected && this.block.value_sel.values_selected.length) {
    //           this.block.value_sel.values_selected.forEach((value: any) => {
    //             if (value.id === el.id) {
    //               this.ordersFormArray.push(new FormControl(true))
    //             } else {
    //               this.ordersFormArray.push(new FormControl(false))
    //             }
    //           });
    //         } else {
    //           this.ordersFormArray.push(new FormControl(false))
    //         }
    //       });
    //   }
    // }
  }

  setTitleDropdown(selectedCheckbox: [{ id: number, name: string }]) {
    if (selectedCheckbox.length === 1) {
      this.isValue = true;
      this.titleDropdown = selectedCheckbox[0].name;
    } else if (selectedCheckbox.length > 1) {
      this.isValue = true;
      this.titleDropdown = this.isCorsiLaureaTutti ? `${this.block['label_' + this.helpersService.langCodeApi]} (${selectedCheckbox.length})` : `${selectedCheckbox.length} ${this.block['label_' + this.helpersService.langCodeApi]}`
    } else {
      this.isValue = false;
      this.titleDropdown = this.block['label_' + this.helpersService.langCodeApi];
    }
  }

  submit() {
    let selectedCheckbox: any;
    if (this.block.filter_type === 'vocabulary[]') {
      selectedCheckbox = this.checkboxGroupForm.value.checkbox.map((checked: any, i: any) => checked ? this.block.value[i] : null).filter((v: null) => v !== null);
    }
    if (this.block.filter_type === 'textList[]') {
      selectedCheckbox = this.checkboxGroupForm.value.checkbox.map((checked: any, i: any) => checked ? this.options[i] : null).filter((v: null) => v !== null);
    }
    this.onSelected.emit({
      // id_block: this.block.id,
      values_selected: selectedCheckbox
    });
    this.setTitleDropdown(selectedCheckbox);
  }

  suggest() {
    if (this.block.filter_type === 'vocabulary[]') {
      this.suggestions = this.block.value.filter((c: any) => c.value.toLowerCase().includes(this.typeahead.value.toLowerCase())).slice(0, this.block.value.length);
      if (this.block.id === 3) {
        if (this.suggestions.length > 0) {
          this.checkArray = of(this.suggestions);
        }
      } else {
        this.checkArray = of(this.block.value);
      }
    }
    if (this.block.filter_type === 'textList[]') {
      this.suggestions = this.options.filter((c: any) => c.value.toLowerCase().includes(this.typeahead.value.toLowerCase())).slice(0, this.options.length);
      if (this.block.id === 3) {
        if (this.suggestions.length > 0) {
          this.checkArray = of(this.suggestions);
        }
      } else {
        this.checkArray = of(this.options);
      }
    }
  }

  get filteredArray() {
    if(this.block.value && this.route.snapshot.url.toString().includes("docenti-lumsa")){
      const opts = this.block.value.filter((el:any) => !el.field_nascosto_per_docenti)
      return of(opts)

    } else return this.checkArray
  }

}
